<template>
    <div class="classify-shell">
        <div class="filtrate-shell">
            <div class="type-shell">
                <div class="type-name">方向</div>
                <div class="type-list">
                    <div class="type-box pointer" @click="cut_direction(item,index)"
                         :class="{'active-box': direction_code==item.group_id }" v-for="(item,index) in direction_list"
                         :key="index">{{item.group_name}}
                    </div>
                </div>
            </div>
            <div class="type-shell">
                <div class="type-name">类别</div>
                <div class="type-list">
                    <div class="type-box pointer" @click="cut_type(item,index)"
                         :class="{'active-box': type_code==item.cate_id }"
                         v-for="(item,index) in nav_list" :key="index">{{item.cate_name}}
                    </div>
                </div>
            </div>
            <div class="type-shell">
                <div class="type-name">排序</div>
                <div class="type-list">
                    <div class="type-box pointer" @click="cut_sort(item,index)"
                         :class="{'active-box':sort_code==item.id }"
                         v-for="(item,index) in sort_list" :key="index">{{item.name}}
                    </div>
                </div>
            </div>
        </div>
        <div class="goods-list">
            <div class="goods-box pointer" v-for="(item,index) in course_list" :key="index"
                 @click="$router.push('/Coursetobuy?course_id='+item.course_id)">
                <div class="goods-img">
                    <img :src="item.course_img" alt="">
                    <div class="goods-type"></div>
                </div>
                <div class="goods-info">
                    <div class="goods-name">
                        {{item.course_name.length>10?item.course_name.substring(0,10)+'...':item.course_name}}
                    </div>
                    <div class="info-bottom">
                        <div class="goods-price">￥{{item.course_price}}</div>
                        <div class="num">
                            <img src="@/assets/date.png" alt="" class="num-icon">
                            {{item.cnt_course}}节
                        </div>
                        <div class="goods-tag">
                            <img class="img3" src="@/assets/coupon.png" alt="" v-if="item.is_coupon"
                                 style="width: 62px;height: 20px;"/>
                            <img class="img3" src="@/assets/group.png" alt="" v-if="item.is_group"
                                 style="width: 46px;height: 20px;"/>
                            <img class="img3" src="@/assets/xs.png" alt="" v-if="item.is_discount"
                                 style="width: 69px;height:20px;"/>
                            <img class="img3" src="@/assets/vip-icon.png" alt="" v-if="item.level_free == 1" style="width: 69px;height:20px;"/>
                        </div>
                    </div>
                </div>
            </div>
            <NoData v-if="course_list.length<1"></NoData>
        </div>
        <div class="paging-shell">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-size="page_size"
                    background layout="prev, pager, next" :total="total"></el-pagination>
        </div>
    </div>
</template>

<script>
  import NoData from '@/components/no-data.vue'

  export default {
    name: 'classify',
    components: {
      NoData
    },
    data () {
      return {
        direction_list: [],
        direction_code: 0,
        type_code: 0,
        sort_list: [
          {
            name: '全部',
            id: 0
          },
          {
            name: '推荐',
            id: 1
          },
          {
            name: '最新',
            id: 2
          },
          {
            name: '精选',
            id: 3
          }
        ],
        is_home: 0,
        is_fine: 0,
        sort_code: '',
        pageIndex: 1,
        total: 0,
        course_list: [],
        page_size: 12,
        nav_list: []
      }
    },
    mounted () {
      window.scrollTo(0, 0)
      this.get_train__list()
      this.get_class_list()
      if (this.$route.query.lv2_id) {
        this.type_code = this.$route.query.lv2_id
      } else if (this.$route.query.lv1_id) {
        this.type_code = this.$route.query.lv1_id
      }
      this.get_list()
    },
    methods: {
      get_train__list () { // 培训对象
        this.API.post('Home/course_out-get_train_list', {}).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.direction_list = [{
            group_name: '全部',
            group_id: 0
          }].concat(res.data.train_list)
        })
      },
      cut_direction (item, index) { // 方向
        this.pageIndex = 1
        this.direction_code = item.group_id
        this.get_list()
      },
      cut_type (item, index) { //类别
        this.pageIndex = 1
        this.type_code = item.cate_id
        this.get_list()
      },
      cut_sort (item, index) { // 排序
        this.pageIndex = 1
        this.sort_code = item.id
        this.is_home = 0
        this.is_fine = 0
        if (this.sort_code === 1) {
          this.is_home = 1
        }
        if (this.sort_code === 3) {
          this.is_fine = 1
        }
        this.get_list()
      },
      get_class_list () {
        this.API.post('Home/course_out-get_course_nav', {}).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.nav_list = [{
            cate_name: '全部',
            cate_id: 0
          }].concat(res.data.nav_list)
        })
      },
      get_list () { // 课程列表
        this.API.post('Home/course_out-get_course_list', {
          group_id: this.direction_code,
          parent_cate: this.type_code,
          is_home: this.is_home, // 推荐
          is_fine: this.is_fine, // 精品
          page_size: this.page_size,
          page: this.pageIndex
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.course_list = res.data.course_list
          this.total = res.data.cont_course
        })
      },
      handleSizeChange (val) { // 每页条数操作
        this.pageIndex = 1
        this.get_list()
      },
      handleCurrentChange (val) { // 页数操作
        this.pageIndex = val
        this.get_list()
      },
    },
    watch: {
      $route: function () {
        if (this.$route.query.lv2_id) {
          this.type_code = this.$route.query.lv2_id
        } else if (this.$route.query.lv1_id) {
          this.type_code = this.$route.query.lv1_id
        }
        this.pageIndex = 1
        this.get_list()
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #2aa9b5 !important;
    }
    .classify-shell {
        width: 1300px;
        margin: auto;
        padding: 20px;
    }

    .classify-shell {
        .filtrate-shell {

            border: 1px solid #DBDBDB;

            .type-shell {
                display: flex;
                align-items: center;
                height: 60px;
                padding: 0 20px;
            }

            .type-name {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                margin-right: 30px;
                min-width: 50px;
            }

            .type-list {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .type-box {
                    display: inline-block;
                    padding: 0 10px;
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 10px;
                }

                .active-box {
                    color: rgba(42, 169, 180, 1);
                }
            }
        }

        .goods-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;

            .goods-box {
                margin-top: 40px;
                width: 22%;
                margin-right: 3%;

                .goods-img {
                    width: 282px;
                    height: 184px;
                    border: 1px solid #eee;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .goods-info {
                    .goods-name {
                        margin-top: 20px;
                        font-size: 24px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #333333;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }

                    .info-bottom {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;

                        img {
                            margin-left: 5px;
                        }

                        .goods-price {
                            font-size: 30px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #D43333;
                            line-height: 60px;
                            margin-right: 15px;
                        }

                        .num {
                            display: flex;
                            align-items: center;
                            font-size: 26px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #656565;
                            line-height: 60px;
                        }

                        .num-icon {
                            min-height: 22px;
                            min-width: 22px;
                            width: 22px;
                            height: 22px;
                            border: 1px solid #eee;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }

        .paging-shell {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 80px;
        }
    }
</style>
